module.exports = __webpack_public_path__ + "static/media/vclass.f4463089.png";